<template>
  <insight :insight="insight"
           :animation-name="'MonthlySaving.json'"
           :button-text="'ספרו לי עוד'"
           :button-action="buttonAction">
    <template v-slot:insight-text>
      <div v-if="!insight.hasSavingEnvelope">
        נראה שאפשר להעביר כל חודש לחיסכון
        <span class="amount">{{ formattedAmount }} ₪</span > בהוראת קבע.<div> כל הכבוד!</div>
      </div>
      <div v-else>
        נראה שאפשר להעביר לחיסכון
        <span class="amount">עוד {{ formattedAmount }} ₪</span >
        כל חודש!
      </div>
    </template>
  </insight>
</template>

<script>
import Segment from '@/Segment';
import DDLogs from '@/DDLogs';
import HarelMonthlySavingPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/insights/components/savings/HarelMonthlySavingPopup';
import cashflowViewConsts from '@/constants/cashflow-view';
import { mapActions } from 'vuex';
import moneyUtils from '@/utils/money';
import Insight from './components/Insight';

export default {
  name: 'HarelMonthlySavingInsight',
  components: {
    Insight,
  },
  props: {
    insight: { type: Object },
  },
  computed: {
    buttons() {
      return [
        {
          text: 'לחיסכון בהראל',
          variant: 'primary',
          action: async () => {
            Segment.trackUserInteraction('HarelMonthlySavingClicked');
            window.open('https://digital.harel-group.co.il/landing-page/long-term-savings/funding-saving-riseup', '_blank');
            this.closePopup();
          },
        },
      ];
    },
    formattedAmount() {
      return moneyUtils.formatAmountWithFraction(this.insight.proposedMonthlySavingAmount, 0);
    },
  },
  methods: {
    ...mapActions('insights', ['markAsRead']),
    ...mapActions('modalRootStore', ['openModal', 'closeModal']),
    buttonAction() {
      const component = HarelMonthlySavingPopup;
      this.openModal({
        component,
        props: {
          cashflowCategory: cashflowViewConsts.CASHFLOW_CATEGORIES.FIXED,
          insight: this.insight,
          closeAction: this.closePopup,
          buttons: this.buttons,
        },
      });
    },
    closePopup() {
      Segment.trackUserGot('MonthlySavingPopupClosed', this.insight);
      this.closeModal();
      this.markAsRead(this.insight).catch(error => {
        DDLogs.error('Failed to mark insight as read', { insight: this.insight, error });
      });
    },
  },
};

</script>

<style lang="scss" scoped>
.amount {
  font-weight: bold;
  white-space: pre;
}
</style>
